<template>
  <v-dialog scrollable :value="showDialog" max-width="500" @input="close">
    <v-card>
      <v-toolbar color="teal" dark>
        <v-toolbar-title>Comments</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-list subheader v-if="commentedUsers.length > 0" class="pt-3">
          <v-list-item
            v-for="commentedUser in commentedUsers"
            :key="commentedUser.id"
          >
            <v-list-item-avatar>
              <view-image
                defaultImage="user"
                :image="commentedUser.user.profile_image"
              ></view-image>
            </v-list-item-avatar>

            <v-list-item-content>
              <strong
                ><v-list-item-title>{{
                  commentedUser.user.name
                }}</v-list-item-title></strong
              >
              <v-spacer></v-spacer>
              {{ commentedUser.comment }}
            </v-list-item-content>
            <v-list-item-content>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    fab
                    x-small
                    absolute
                    right
                    @click="
                      commentedUser.status_id == 2
                        ? toggleStatus(commentedUser.id, 1)
                        : toggleStatus(commentedUser.id, 2)
                    "
                  >
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </template>
                Delete
              </v-tooltip>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list>
        <div
          v-else
          style="height: 200px"
          class="d-flex justify-center align-center"
        >
          No Users Commented
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close()" class="ma-2 white--text blue-color" text
          >Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    postID: { type: Number, default: null },
    type: { type: String, default: "details" },
  },
  data() {
    return {
      showDialog: false,
      commentedUsers: [],
    };
  },
  watch: {
    postID(val) {
      if (val != null) {
        this.showDialog = true;
        this.opencommentedUsers();
      }
    },
  },
  methods: {
    opencommentedUsers() {
      this.showLoader("Loading");
      this.$http.get(`posts/${this.postID}/comments`).then((response) => {
        if (response.status == 200 && response.data.status == true) {
          const data = response.data.data;
          this.commentedUsers = data;
          this.hideLoader();
        }
      });
    },

    toggleStatus(id, status_id) {
      this.$http
        .put(`admin/delete-comment/` + id + `/` + status_id)
        .then((response) => {
          if (response.status == 200) {
            this.opencommentedUsers();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    close() {
      this.showDialog = false;
      this.$emit("close");
    },
  },
};
</script>

<style></style>
